import React, { memo } from 'react';
import { Loading } from './styled';

export const PageLoading = memo(() => <Loading />);
